import React from "react";
import AppFooter from "./AppFooter";

export default function AppLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-slate-50 via-cyan-50 to-blue-100">
      
      {/* Page Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer always at bottom */}
      <AppFooter />
    </div>
  );
}